import React from 'react';
import { Col, Row } from 'antd';
import { useQueryClient } from 'react-query';

import { CandidatesPersonalData } from '../candidate-details/CandidatesPersonalData';
import { useUpdateCandidate } from '../candidate-details/useUpdateCandidate';
import { CandidateType } from '../candidates/Candidates.types';

import { CandidateDescription } from './CandidateDescription';

type CandidateProps = {
  candidate: CandidateType;
  height: number;
};

export const Candidate: React.FC<CandidateProps> = ({ candidate, height }) => {
  const updateCandidate = useUpdateCandidate();
  const queryClient = useQueryClient();

  const attachCV = (fileId: string) => {
    updateCandidate.mutate(
      { queryParams: { id: candidate?.uuid ?? '' }, data: { cv: fileId } },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(`/candidates/${candidate?.uuid}`);
        },
      }
    );
  };

  return (
    <Row gutter={[15, 15]}>
      <Col xs={24} xl={8}>
        <CandidateDescription candidate={candidate} />
      </Col>
      <Col xs={24} xl={16}>
        <CandidatesPersonalData cvAttachement={candidate.cv?.uuid} updateCVAttachement={attachCV} height={height} />
      </Col>
    </Row>
  );
};
